<template>
  <div class="container-fluid px-0">
    <div class="card mb-3 mt-3 mx-2 mx-md-4">
   

      <div class="card-body px-0 pb-0">
        <!-- Loading/Error States -->
        <div v-if="isLoading" class="text-center py-4">
          <div class="spinner-border text-primary" style="width: 2rem; height: 2rem;" role="status">
            <span class="visually-hidden">{{ $t('adminDashboard.loadingData') }}</span>
          </div>
          <p class="mt-2 mb-0">{{ $t('adminDashboard.loadingData') }}</p>
        </div>

        <div v-else-if="error" class="alert alert-danger mx-3 mx-md-4 mb-3 py-2">
          <i class="fas fa-exclamation-triangle me-2"></i> {{ error }}
        </div>

        <!-- Main Content -->
        <div v-else>
       

          <!-- Quick Actions and Charts Row -->
          <div class="row g-2 mx-1 mx-md-3">
            <!-- Quick Actions - Full width on mobile -->
            <div class="col-12 col-lg-12 mb-2">
              <div class="card shadow h-100">
                <div class="card-header bg-gradient-primary py-3">
                  <h6 class="m-0 font-weight-bold text-white mx-2" style="font-size: clamp(0.9rem, 3vw, 1rem);">{{ $t('adminDashboard.quickActions') }}</h6>
                </div>
                <div class="card-body p-2">
                  <div class="row g-2">
                    <!-- Add Student -->
                    <div class="col-6 col-md-4 col-lg-2">
                      <router-link 
                        to="/students/add" 
                        class="btn btn-outline-primary w-100 h-100 py-2 d-flex flex-column align-items-center justify-content-center"
                        style="min-height: 100px;"
                      >
                        <i class="fas fa-user-plus mb-2" style="font-size: 1.5rem;"></i>
                        <span style="font-size: clamp(0.7rem, 2vw, 0.85rem);">  {{ $t('adminDashboard.addNewStudent') }}
</span>
                      </router-link>
                    </div>
                    
                    <!-- Add Teacher -->
                    <div class="col-6 col-md-4 col-lg-2">
                      <router-link 
                        to="/teachers/create" 
                        class="btn btn-outline-primary w-100 h-100 py-2 d-flex flex-column align-items-center justify-content-center"
                        style="min-height: 100px;"
                      >
                        <i class="fas fa-chalkboard-teacher mb-2" style="font-size: 1.5rem;"></i>
                        <span style="font-size: clamp(0.7rem, 2vw, 0.85rem);">  {{ $t('adminDashboard.addNewTeacher') }}
</span>
                      </router-link>
                    </div>
                    
                    <!-- Create Class -->
                    <div class="col-6 col-md-4 col-lg-2">
                      <router-link 
                        to="/classes/add" 
                        class="btn btn-outline-primary w-100 h-100 py-2 d-flex flex-column align-items-center justify-content-center"
                        style="min-height: 100px;"
                      >
                        <i class="fas fa-chalkboard mb-2" style="font-size: 1.5rem;"></i>
                        <span style="font-size: clamp(0.7rem, 2vw, 0.85rem);">  {{ $t('adminDashboard.createNewClass') }}
</span>
                      </router-link>
                    </div>
                    
                    <!-- Create Subject -->
                    <div class="col-6 col-md-4 col-lg-2">
                      <router-link 
                        to="/subjects/add" 
                        class="btn btn-outline-primary w-100 h-100 py-2 d-flex flex-column align-items-center justify-content-center"
                        style="min-height: 100px;"
                      >
                        <i class="fas fa-book mb-2" style="font-size: 1.5rem;"></i>
                        <span style="font-size: clamp(0.7rem, 2vw, 0.85rem);">  {{ $t('adminDashboard.addNewSubject') }}
</span>
                      </router-link>
                    </div>
                    
                    <!-- Create Announcement -->
                    <div class="col-6 col-md-4 col-lg-2">
                      <router-link 
                        to="/announcements/create" 
                        class="btn btn-outline-primary w-100 h-100 py-2 d-flex flex-column align-items-center justify-content-center"
                        style="min-height: 100px;"
                      >
                        <i class="fas fa-bullhorn mb-2" style="font-size: 1.5rem;"></i>
                        <span style="font-size: clamp(0.7rem, 2vw, 0.85rem);">  {{ $t('adminDashboard.createAnnouncement') }}
</span>
                      </router-link>
                    </div>
                    
                    <!-- Manage Payments -->
                    <div class="col-6 col-md-4 col-lg-2">
                      <router-link 
                        to="/payment-receipts" 
                        class="btn btn-outline-primary w-100 h-100 py-2 d-flex flex-column align-items-center justify-content-center"
                        style="min-height: 100px;"
                      >
                        <i class="fas fa-money-bill-wave mb-2" style="font-size: 1.5rem;"></i>
                        <span style="font-size: clamp(0.7rem, 2vw, 0.85rem);">  {{ $t('adminDashboard.managePayments') }}</span>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          <!-- Stats Cards Row -->
          <div class="row g-2 mb-4 mx-1 mx-md-3">
            <!-- Students Card -->
            <div class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0">
              <div class="card border-left-primary shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                          {{ $t('adminDashboard.totalStudents') }}

                      </div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">
                        {{ stats.studentsCount || 0 }}
                      </div>
                      <div class="text-xs text-muted mt-1">
                        <i class="fas fa-user-plus me-1"></i> {{ stats.newStudentsThisMonth || 0 }}   {{ $t('adminDashboard.newThisMonth') }}

                      </div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-users fa-2x text-gray-300"></i>
                    </div>
                  </div>
                  <router-link to="/students" class="small text-primary text-decoration-none d-block mt-2">
  {{ $t('adminDashboard.viewAll') }}
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Teachers Card -->
            <div class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0">
              <div class="card border-left-info shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
                      {{ $t('adminDashboard.totalTeachers') }}

                      </div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">
                        {{ stats.teachersCount || 0 }}
                      </div>
                      <div class="text-xs text-muted mt-1">
                        <i class="fas fa-male me-1"></i> {{ stats.maleTeachersCount || 0 }}   {{ $t('adminDashboard.maleTeachers') }}

                      </div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-chalkboard-teacher fa-2x text-gray-300"></i>
                    </div>
                  </div>
                  <router-link to="/teachers" class="small text-info text-decoration-none d-block mt-2">
  {{ $t('adminDashboard.viewAll') }}
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Classes Card -->
            <div class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0">
              <div class="card border-left-success shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                    {{ $t('adminDashboard.totalClasses') }}
                      </div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">
                        {{ stats.classesCount || 0 }}
                      </div>
                      <div class="text-xs text-muted mt-1">
                        <i class="fas fa-check-circle me-1"></i> {{ stats.activeClassesCount || 0 }}   {{ $t('adminDashboard.activeClasses') }}

                      </div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-chalkboard fa-2x text-gray-300"></i>
                    </div>
                  </div>
                  <router-link to="/classes" class="small text-success text-decoration-none d-block mt-2">
  {{ $t('adminDashboard.viewAll') }}
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Subjects Card -->
            <div class="col-12 col-sm-6 col-xl-3 mb-2 mb-xl-0">
              <div class="card border-left-warning shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                      {{ $t('adminDashboard.totalSubjects') }} 
                      </div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">
                        {{ stats.subjectsCount || 0 }}
                      </div>
                      <div class="text-xs text-muted mt-1">
                        <i class="fas fa-tasks me-1"></i> {{ stats.assignmentsCount || 0 }}   {{ $t('adminDashboard.assignments') }}

                      </div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-book-open fa-2x text-gray-300"></i>
                    </div>
                  </div>
                  <router-link to="/subjects" class="small text-warning text-decoration-none d-block mt-2">
                      {{ $t('adminDashboard.viewAll') }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>

            <!-- Charts Section -->
            <!-- Attendance Chart -->
            <div class="col-12 mb-4">
              <div class="card shadow">
                <div class="card-header bg-gradient-primary py-3">
                  <h6 class="m-0 font-weight-bold text-white mx-2">  {{ $t('adminDashboard.studentAttendance') }}
</h6>
                </div>
                <div class="card-body p-2">
                  <div style="height: 200px; width: 100%;">
                    <canvas ref="attendanceChartRef" width="400" height="200"></canvas>
                  </div>
                </div>
              </div>
            </div>

            <!-- Students by Class Chart -->
            <div class="col-12 mb-4">
              <div class="card shadow">
                <div class="card-header bg-gradient-primary py-3">
                  <h6 class="m-0 font-weight-bold text-white mx-2">  {{ $t('adminDashboard.studentDistribution') }}
</h6>
                </div>
                <div class="card-body p-2">
                  <div style="height: 200px; width: 100%;">
                    <canvas ref="studentsByClassChartRef" width="400" height="200"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Recent Students and Announcements Row -->
          <div class="row g-2 mx-1 mx-md-3 mt-2">
            <!-- Recent Students - Full width -->
            <div class="col-12 mb-2">
              <div class="card shadow-sm h-100">
                <div class="card-header bg-gradient-primary py-3">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="m-0 text-white mx-2" style="font-size: clamp(0.8rem, 3vw, 1rem);">
                        {{ $t('adminDashboard.recentStudents') }}

                    </h6>
                    <router-link to="/students" class="btn btn-sm btn-link text-white mx-2" style="font-size: clamp(0.7rem, 2.5vw, 0.85rem);">
  {{ $t('adminDashboard.viewAll') }}
                    </router-link>
                  </div>
                </div>
                <div class="card-body p-1">
                  <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                    <table class="table table-sm align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xs fw-bolder opacity-7" style="font-size: clamp(0.6rem, 2vw, 0.75rem);">  {{ $t('adminDashboard.studentName') }}
</th>
                          <th class="text-uppercase text-secondary text-xs fw-bolder opacity-7 d-none d-sm-table-cell" style="font-size: clamp(0.6rem, 2vw, 0.75rem);">  {{ $t('adminDashboard.class') }}
</th>
                          <th class="text-uppercase text-secondary text-xs fw-bolder opacity-7 d-none d-md-table-cell" style="font-size: clamp(0.6rem, 2vw, 0.75rem);">  {{ $t('adminDashboard.registerDate') }}</th>
                          <th class="text-uppercase text-secondary text-xs fw-bolder opacity-7" style="font-size: clamp(0.6rem, 2vw, 0.75rem);">  {{ $t('adminDashboard.actions') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="student in recentStudents" :key="student.id">
                          <td class="align-middle">
                            <div class="d-flex align-items-center">
                              <img :src="student.image_url || '/images/default-avatar.png'" 
                                  class="avatar rounded-circle me-2"
                                  style="width: 30px; height: 30px; object-fit: cover;">
                              <div class="d-flex flex-column">
                                <span class="text-xs fw-bold mb-0" style="font-size: clamp(0.65rem, 2.5vw, 0.8rem);">
                                  {{ student.first_name }} {{ student.father_name }} {{ student.last_name }}
                                </span>
                                <span class="text-xs text-secondary d-none d-sm-inline-block" style="font-size: clamp(0.55rem, 2vw, 0.65rem);">
                                  {{ student.national_num }}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle d-none d-sm-table-cell">
                            <span class="badge badge-sm bg-primary" v-if="student.class && student.class.name" style="font-size: clamp(0.55rem, 2vw, 0.65rem);">
                              {{ student.class.name }}
                            </span>
                            <span class="badge badge-sm bg-secondary" v-else style="font-size: clamp(0.55rem, 2vw, 0.65rem);">
  {{ $t('adminDashboard.notRegistered') }}
                            </span>
                          </td>
                          <td class="align-middle text-xs d-none d-md-table-cell" style="font-size: clamp(0.6rem, 2vw, 0.7rem);">
                            {{ formatDate(student.register_date) }}
                          </td>
                          <td class="align-middle">
                            <router-link :to="`/students/${student.id}`" 
                                        class="btn btn-sm btn-outline-primary px-2"
                                        style="font-size: clamp(0.6rem, 2vw, 0.7rem);">
  {{ $t('adminDashboard.details') }}
                            </router-link>
                          </td>
                        </tr>
                        <tr v-if="recentStudents.length === 0">
                          <td colspan="4" class="text-center py-3 text-muted">

  {{ $t('adminDashboard.noRecentStudents') }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import Chart from 'chart.js/auto'
import api from '@/api'

const isLoading = ref(true)
const error = ref(null)
const stats = ref({
  studentsCount: 0,
  newStudentsThisMonth: 0,
  teachersCount: 0,
  maleTeachersCount: 0,
  classesCount: 0,
  activeClassesCount: 0,
  subjectsCount: 0,
  assignmentsCount: 0,
  pendingAssignmentsCount: 0,
  totalPayments: 0,
  pendingPaymentsCount: 0,
  activeAnnouncementsCount: 0
})

const recentStudents = ref([])

const attendanceChartRef = ref(null)
const studentsByClassChartRef = ref(null)
const attendanceChartInstance = ref(null)
const studentsByClassChartInstance = ref(null)

const formatDate = (dateString) => {
  if (!dateString) return 'غير محدد'
  const date = new Date(dateString)
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
  }
  return date.toLocaleDateString('ar', options)
}



const initCharts = async () => {
  await nextTick(); 

  if (attendanceChartInstance.value) {
    attendanceChartInstance.value.destroy();
  }
  if (studentsByClassChartInstance.value) {
    studentsByClassChartInstance.value.destroy();
  }

  try {
    const [attendanceResponse, studentsByClassResponse] = await Promise.all([
      api.get('/admin/dashboard/student-attendance-data'),
      api.get('/admin/dashboard/students-by-class-data')
    ]);

    console.log('API Responses:', {
      attendance: attendanceResponse.data,
      studentsByClass: studentsByClassResponse.data
    });

    if (attendanceChartRef.value && attendanceResponse.data.success) {
      const ctx = attendanceChartRef.value.getContext('2d');
      attendanceChartInstance.value = new Chart(ctx, {
        type: 'bar',
data: attendanceResponse.data.data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              rtl: true,
              labels: {
                font: {
                  family: 'Tahoma, Arial, sans-serif'
                },
                padding: 20
              }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                mirror: true
              }
            },
            x: {
              ticks: {
                mirror: true
              }
            }
          }
        }
      });
    }

    if (studentsByClassChartRef.value && studentsByClassResponse.data.success) {
      const ctx = studentsByClassChartRef.value.getContext('2d');
      studentsByClassChartInstance.value = new Chart(ctx, {
        type: 'doughnut',
data: studentsByClassResponse.data.data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right',
              rtl: true,
              labels: {
                font: {
                  family: 'Tahoma, Arial, sans-serif'
                },
                padding: 20,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            }
          },
          cutout: '70%'
        }
      });
    }
  } catch (err) {
    console.error('Error loading chart data:', err);
  }
};

let announcementInterval = null

const fetchDashboardData = async () => {
  try {
    isLoading.value = true
    error.value = null
    
    const [
      statsResponse, 
      recentStudentsResponse, 
    ] = await Promise.all([
      api.get('/admin/dashboard/stats'),
      api.get('/admin/dashboard/recent-students'),
      api.get('/admin/dashboard/recent-announcements')
    ])

    stats.value = statsResponse.data.data
    recentStudents.value = recentStudentsResponse.data

    await initCharts()
  } catch (err) {
    console.error('Error fetching dashboard data:', err)
    error.value = 'فشل تحميل بيانات لوحة التحكم. يرجى المحاولة مرة أخرى.'
    
    await initCharts()
  } finally {
    isLoading.value = false
  }
}

onMounted(async () => {
  await fetchDashboardData();
  await nextTick(); 
  initCharts();
});

onUnmounted(() => {
  if (attendanceChartInstance.value) {
    attendanceChartInstance.value.destroy()
  }
  if (studentsByClassChartInstance.value) {
    studentsByClassChartInstance.value.destroy()
  }
  if (announcementInterval) {
    clearInterval(announcementInterval)
  }
})
</script>

<style scoped>
.card {
  border-radius: 0.5rem;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
  transition: all 0.3s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 2rem 0 rgba(58, 59, 69, 0.2);
}

.card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.border-left-primary {
  border-left: 0.25rem solid #9c27b0 !important;
}

.border-left-success {
  border-left: 0.25rem solid #2c91ae !important;
}

.border-left-info {
  border-left: 0.25rem solid #36b9cc !important;
}

.border-left-warning {
  border-left: 0.25rem solid #f6c23e !important;
}

.text-xs {
  font-size: 0.7rem;
}

.text-sm {
  font-size: 0.85rem;
}

.avatar {
  width: 36px;
  height: 36px;
  object-fit: cover;
}

.chart-container {
  position: relative;
  height: 100%;
  min-height: 200px;
}

.btn-outline-primary {
  transition: all 0.3s;
}

.btn-outline-primary:hover {
  color: white !important;
}

.text-gray-800 {
  color: #5a5c69 !important;
}

.text-gray-300 {
  color: #dddfeb !important;
}

.announcement-carousel-container {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  margin: 1rem 0;
  direction: rtl;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.carousel-slides {
  display: flex;
  height: 100%;
  width: 100%;
}

.carousel-slide {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  position: relative;
}

.announcement-card {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #f8f9fa;
}

.announcement-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: rgba(0, 0, 0, 0.6);
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.3);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s;
}

.carousel-control:hover {
  background: rgba(255, 255, 255, 0.5);
  transform: translateY(-50%) scale(1.1);
}

.carousel-control.prev {
  right: 1rem;
}

.carousel-control.next {
  left: 1rem;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.carousel-indicators button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  padding: 0;
  transition: all 0.3s;
}

.carousel-indicators button.active {
  background: white;
  transform: scale(1.2);
}

.carousel-indicators button:hover {
  transform: scale(1.2);
}

@media (max-width: 767.98px) {
  .card-header h6 {
    font-size: 0.9rem !important;
  }
  
  .card-body {
    padding: 0.75rem !important;
  }
  
  .quick-actions .btn {
    padding: 0.5rem !important;
    font-size: 0.75rem !important;
  }
  .announcement-scope {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 10;
  font-size: .8rem;
  padding: .4rem .6rem;
}

[dir="rtl"] .announcement-scope {
  left: auto;
  right: 20px;
}

  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .carousel-control {
    width: 30px;
    height: 30px;
    font-size: 0.8rem;
  }
  
  .announcement-overlay {
    padding: 1rem;
  }
  
  .quick-actions .col-6 {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 575.98px) {
  .stats-card .col-12 {
    margin-bottom: 0.5rem;
  }
  
  .carousel-wrapper {
    height: 250px;
  }
  
  .carousel-control {
    width: 25px;
    height: 25px;
    font-size: 0.7rem;
  }
  
  .announcement-title {
    font-size: 1rem !important;
  }
  
  .quick-actions .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .table thead th.d-none {
    display: none !important;
  }
  
  .table tbody td.d-none {
    display: none !important;
  }
  
  .avatar {
    width: 30px;
    height: 30px;
  }
  
  .badge {
    font-size: 0.6rem !important;
    padding: 0.25rem 0.5rem;
  }
}

canvas {
  max-width: 100%;
  height: auto !important;
}

[dir="rtl"] .carousel-control.prev {
  right: auto;
  left: 1rem;
}

[dir="rtl"] .carousel-control.next {
  left: auto;
  right: 1rem;
}

.card-body {
  word-wrap: break-word;
}

.btn {
  padding: 0.5rem 1rem;
  min-width: 44px;
  min-height: 44px;
}

.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}

.table td, .table th {
  font-size: 0.8rem;
}

img {
  max-width: 100%;
  height: auto;
}

.carousel-indicators button {
  width: 8px;
  height: 8px;
  margin: 0 2px;
}

.announcement-overlay {
  padding: 1rem;
}

.quick-actions .btn {
  margin-bottom: 0.5rem;
}

.text-truncate {
  white-space: normal;
}

[dir="rtl"] .text-end {
  text-align: left !important;
}

[dir="rtl"] .text-start {
  text-align: right !important;
}

[dir="rtl"] .position-absolute.start-0 {
  right: 0 !important;
  left: auto !important;
}

[dir="rtl"] .position-absolute.end-0 {
  left: 0 !important;
  right: auto !important;
}
.glass-badge{
  background: rgba(255,255,255,.12);
  color:#fff;
  border:1px solid rgba(255,255,255,.3);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  font-weight:800;
  letter-spacing:.2px;
}
/* Styled announcements (match announcements.index look) */
.announcement-carousel-container {
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  margin: 1rem 0;
  direction: rtl;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 450px; /* similar to styled component; adjust to taste */
  overflow: hidden;
}

.carousel-slides {
  display: flex;
  height: 100%;
  width: 100%;
}

.carousel-slide {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  position: relative;
}

.announcement-card {
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0,0,0,.1);
}

.announcement-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.announcement-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  color: #6c757d;
}

.announcement-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.announcement-content {
  max-width: 800px;
  width: 100%;
  color: #fff;
  text-align: center;
  padding: 2rem;
}

.announcement-title {
  font-size: 1.6rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0,0,0,.5);
}

.announcement-description {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  text-shadow: 0 1px 3px rgba(0,0,0,.5);
}

.announcement-badge {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  font-size: .8rem;
  padding: .5rem .75rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,.2);
}

.announcement-date {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  font-size: .9rem;
  padding: .5rem .75rem;
  border-radius: 4px;
  background: rgba(255,255,255,.2);
  color: #fff;
  display: flex;
  align-items: center;
}

/* Controls & indicators (same style) */
.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255,255,255,.3);
  border: none;
  color: #fff;
  width: 40px; height: 40px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all .3s;
}
.carousel-control:hover { background: rgba(255,255,255,.5); transform: translateY(-50%) scale(1.1); }
.carousel-control.prev { right: 1rem; }
.carousel-control.next { left: 1rem; }

.carousel-indicators {
  display: flex; justify-content: center; gap: .5rem; margin-top: 1rem;
}
.carousel-indicators button {
  width: 10px; height: 10px; border-radius: 50%; border: none;
  background: rgba(255,255,255,.5); cursor: pointer; padding: 0; transition: all .3s;
}
.carousel-indicators button.active { background: #fff; transform: scale(1.2); }
.carousel-indicators button:hover { transform: scale(1.2); }

/* RTL control swap (if needed) */
[dir="rtl"] .carousel-control.prev { right: 1rem; left: auto; }
[dir="rtl"] .carousel-control.next { left: 1rem; right: auto; }

@media (max-width: 768px) {
  .carousel-wrapper { height: 400px; }
  .announcement-title { font-size: 1.3rem; }
  .announcement-description { font-size: .9rem; margin-bottom: 1rem; }
}

@media (max-width: 576px) {
  .carousel-wrapper { height: 350px; }
  .announcement-badge, .announcement-date {
    font-size: .7rem; padding: .3rem .5rem;
  }
}
.announcement-scope {
  position: absolute;
  bottom: 20px;
  left: 20px;     
  z-index: 10;
  font-size: .8rem;
  padding: .45rem .65rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,.2);
}

[dir="rtl"] .announcement-scope {
  left: auto;
  right: 20px;
}
.announcement-scope-container {
  position: absolute;
  bottom: 20px;
  left: 20px;
  z-index: 10;
  max-width: calc(100% - 40px);
}

[dir="rtl"] .announcement-scope-container {
  left: auto;
  right: 20px;
}

.announcement-scope-container .badge {
  font-size: 0.7rem;
  padding: 0.4rem 0.6rem;
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}

@media (max-width: 576px) {
  .announcement-scope-container {
    bottom: 16px;
    left: 16px;
  }
  
  [dir="rtl"] .announcement-scope-container {
    left: auto;
    right: 16px;
  }
  
  .announcement-scope-container .badge {
    font-size: 0.65rem;
    padding: 0.3rem 0.5rem;
  }
}
@media (max-width: 576px) {
  .announcement-scope {
    font-size: .7rem;
    padding: .35rem .5rem;
    bottom: 16px;
  }
}
</style>